<template>
    <ListenerPlaylistDetails v-if="isListenerMobile" />
    <Playlist v-else />
</template>

<script>
import Playlist from './Playlist.vue'
import ListenerPlaylistDetails from './ListenerPlaylistDetails.vue'

export default {
    name: 'PlaylistEntry',
    components: {
        Playlist,
        ListenerPlaylistDetails
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
